import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { Badge, IconButton, TextButton, TextField, Tooltip, Typography } from 'seagull';
import { Trash } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import ChangesApprovalInfoBox from '../ChangesApprovalInfoBox/ChangesApprovalInfoBox';
import styles from './AmendmentChanges.module.scss';
function AmendmentNote(props) {
    const { t: texts } = useLocaleKeys('components.amendmentChanges');
    const { testId, existingNote, isUnsaved, onNoteChange } = props;
    const [note, setNote] = useState(existingNote || '');
    const [addingNote, setAddingNote] = useState(!!existingNote);
    return isUnsaved ? /*#__PURE__*/ _jsx("div", {
        className: styles.note,
        children: addingNote ? /*#__PURE__*/ _jsx(TextField, {
            bi: {
                name: 'amendment_note'
            },
            collapseHelperText: false,
            multiline: true,
            label: texts.noteLabel(),
            value: note,
            testId: testId && "".concat(testId, "-note"),
            onChange: (e)=>{
                const newNote = e.target.value;
                setNote(newNote);
                onNoteChange && onNoteChange(newNote);
            }
        }) : /*#__PURE__*/ _jsx(TextButton, {
            underline: "none",
            testId: testId && "".concat(testId, "-add-note"),
            onClick: ()=>setAddingNote(true),
            children: "+ Add Note"
        })
    }) : existingNote ? /*#__PURE__*/ _jsxs("div", {
        className: styles.note,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                as: "span",
                children: "Note:"
            }),
            ' ',
            /*#__PURE__*/ _jsx(Typography, {
                as: "span",
                testId: testId && "".concat(testId, "-readonly-note"),
                children: existingNote
            })
        ]
    }) : null;
}
export default function AmendmentChanges(props) {
    const { t: texts } = useLocaleKeys('components.amendmentChanges');
    const { items, testId, autoApprovalDate, isUnsaved, disableNote, disableDiscard, disableRequiresApprovalBadges, disableApprovalInfoBox, disableBorderRadius, title = texts.defaultTitle(), onDiscard } = props;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.changes, {
            [styles.disableBorderRadius]: disableBorderRadius
        }),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.title,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        weight: "normal",
                        children: title
                    }),
                    items.length > 0 && !disableDiscard && /*#__PURE__*/ _jsx(Tooltip, {
                        title: texts.discardTooltip(),
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            bi: {
                                name: 'discard_amendment_changes'
                            },
                            type: "button",
                            size: "small",
                            noPadding: true,
                            testId: testId && "".concat(testId, "-discard"),
                            onClick: onDiscard,
                            children: /*#__PURE__*/ _jsx(Trash, {
                                size: 16
                            })
                        })
                    })
                ]
            }),
            items.length > 0 && /*#__PURE__*/ _jsx("ul", {
                className: styles.items,
                children: items.map((param, idx)=>{
                    let { text, requiresApproval } = param;
                    return /*#__PURE__*/ _jsx(Typography, {
                        as: "li",
                        className: styles.item,
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.itemContent,
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    as: "span",
                                    testId: testId && "".concat(testId, "-").concat(idx),
                                    children: text
                                }),
                                requiresApproval && !disableRequiresApprovalBadges && /*#__PURE__*/ _jsx(Badge, {
                                    outlined: true,
                                    rounded: true,
                                    skin: "warning",
                                    className: styles.requiresApproval,
                                    testId: testId && "".concat(testId, "-").concat(idx, "-requires-approval"),
                                    children: "Requires approval"
                                })
                            ]
                        })
                    }, text);
                })
            }),
            !disableNote && /*#__PURE__*/ _jsx(AmendmentNote, _object_spread({}, props)),
            !disableApprovalInfoBox && !isUnsaved && items.some((item)=>item.requiresApproval) && /*#__PURE__*/ _jsx(ChangesApprovalInfoBox, {
                className: styles.infoBox,
                testId: testId && "".concat(testId, "-approval-info"),
                autoApprovalDate: autoApprovalDate
            })
        ]
    });
}
